/* eslint-disable no-unused-vars */
import {
  buildSearchEngine,
  getSampleSearchEngineConfiguration
} from '@coveo/headless';

const wrapper =
  document.getElementsByClassName('coveo-search-results__main-wrapper')[0] ||
  document.getElementsByClassName('coveo-search-results__global-search-box')[0];

const { dataset } = wrapper;

const coveoConfig = JSON.parse(dataset.coveo);

const originLevel3 = document.referrer || 'undefined';

export const config = {
  organizationId: coveoConfig.OrganizationId,
  accessToken: coveoConfig.ApiKey,
  redirectionUrl: dataset.resultsPage,
  search: {
    preprocessSearchResponseMiddleware: response => {
      response.body.results.forEach(result => result);
      return response;
    },
    preprocessFacetSearchResponseMiddleware: response => response,
    preprocessQuerySuggestResponseMiddleware: response => response
  },
  preprocessRequest: (request, clientOrigin) => {
    if (clientOrigin === 'searchApiFetch') {
      // E.g., modify facet requests
      if (window.preProcessRequest) {
        let body = JSON.parse(request.body);
        body = window.preProcessRequest(request.body.toString());

        // body.facets = [...];
        request.body = body;
      }
    }

    if (clientOrigin === 'analyticsFetch') {
      // E.g., send data to a third party
    }

    return request;
  },
  analytics: {
    originLevel3
  }
};

export const headlessEngine = buildSearchEngine({
  configuration: config
});

export const headlessSearchEngine = buildSearchEngine({
  configuration: config
});
